import logo from 'Assets/img/mono-logo-black.png';

const LoadingSite = () => {
  return <img className="loader" src={logo} alt="Nui" />;
};

export default LoadingSite;
